import { useListStoreGroupsQuery } from '__codegen__/api'
import { edgesToCollection } from 'legacy/apollo/utils/edgesToCollection'
import { useRetailerId } from 'utils/routing/params.hooks'
import { Flipper } from 'legacy/contexts/flipper/FlipperContext'
import useAccessControl from 'legacy/components/AccessControl/useAccessControl'

export const storeGroupListDefaultParams = {
  numGroups: 200,
}

// Right now we are using the old table implementation, and API pagination hasn't been implemented
// Once we have updated it and implemented API pagination, we can remove the cap for max_pagination_nodes
// and replace it with proper pagination
export const useListStoreGroups = () => {
  // Note that this hook will return no data for users that don't have store groups access
  const hasAccess = useAccessControl()
  const storeGroupsFlipperEnabled = hasAccess({ flippers: [Flipper.StoreGroups] })

  const retailerId = useRetailerId()

  const { data, error, loading, refetch } = useListStoreGroupsQuery({
    variables: {
      ...storeGroupListDefaultParams,
      retailerId,
    },
    // If the store groups flipper is not enabled, we skip making this request
    // and then we return our own data
    skip: !storeGroupsFlipperEnabled,
  })

  if (!storeGroupsFlipperEnabled) {
    return {
      storeGroups: [],
      loading: false,
      error: undefined,
      refetch,
    }
  }

  const edges = (data && data.retailerLocationGroupsByRetailer.edges) || []
  const storeGroups = edgesToCollection(edges)

  return {
    storeGroups,
    loading,
    error,
    refetch,
  }
}
